import { createQueryKeys } from '@lukemorales/query-key-factory';

export const queryKeys = createQueryKeys('rewards', {
	list: ({
		campaignId,
		influencerId = undefined,
		search = undefined,
		rewardAmountGTOE = undefined,
		rewardAmountLTOE = undefined,
		rewardDateGTOE = undefined,
		rewardDateLTOE = undefined,
		skip = 0,
		limit = 10,
	}: Partial<RewardQueries.List>) => ({
		campaignId,
		influencerId,
		search,
		rewardAmountGTOE,
		rewardAmountLTOE,
		rewardDateGTOE,
		rewardDateLTOE,
		skip,
		limit,
	}),

	/**
	 * Exports a csv of the Rewards report
	 */
	exportRewardsReport: (params: RewardQueries.ExportRewards) => ({ ...params }),
});
